export default __webpack_public_path__ + "static/media/thunder-logo.93819984.svg";